<div #pageContainer class="flex flex-col h-full">
  @if (loading) {
    <maximizer-loader type="legacy"></maximizer-loader>
  }

  @if (form) {
    <div class="flex flex-col h-full overflow-hidden">
      <div class="flex-1 overflow-y-auto scrollbar pb-4">
        <form class="flex flex-col p-4 text-xs" [formGroup]="form.group">
          <kendo-formfield>
            <kendo-label
              [for]="firstName"
              [text]="'outlook.abentry.firstName' | translate"
            ></kendo-label>
            <kendo-textbox
              [maxlength]="80"
              #firstName
              formControlName="firstName"
            ></kendo-textbox>
            <maximizer-outlook-form-error
              [errorObject]="form.controls.firstName.errors"
              [fieldTranslation]="'outlook.abentry.firstName'"
            ></maximizer-outlook-form-error>
          </kendo-formfield>

          <kendo-formfield class="mt-2">
            <kendo-label
              [for]="lastName"
              [text]="'outlook.abentry.lastName' | translate"
              >*</kendo-label
            >
            <kendo-textbox
              [maxlength]="80"
              required
              #lastName
              formControlName="lastName"
            ></kendo-textbox>
            <maximizer-outlook-form-error
              [errorObject]="form.controls.lastName.errors"
              [fieldTranslation]="'outlook.abentry.lastName'"
            ></maximizer-outlook-form-error>
          </kendo-formfield>

          <kendo-label
            class="mt-2"
            [text]="'outlook.abentry.email' | translate"
          ></kendo-label>
          @for (email of emails; track $index) {
            <ng-container
              *ngTemplateOutlet="
                templateRef;
                context: {
                  $implicit: emails,
                  index: $index,
                  prop: 'email' + ($index + 1),
                }
              "
            ></ng-container>
          }

          <kendo-label
            class="mt-2"
            [text]="'outlook.abentry.phone' | translate"
          ></kendo-label>
          @for (phone of phones; track $index) {
            <ng-container
              *ngTemplateOutlet="
                templateRef;
                context: {
                  $implicit: phones,
                  index: $index,
                  prop: 'phone' + ($index + 1),
                }
              "
            ></ng-container>
          }

          <kendo-formfield class="mt-2">
            <kendo-label
              [for]="position"
              [text]="'outlook.abentry.position' | translate"
            ></kendo-label>
            <kendo-textbox
              [maxlength]="80"
              #position
              formControlName="position"
            ></kendo-textbox>
            <maximizer-outlook-form-error
              [errorObject]="form.controls.position.errors"
              [fieldTranslation]="'outlook.abentry.position'"
            ></maximizer-outlook-form-error>
          </kendo-formfield>

          <kendo-formfield class="mt-2">
            <kendo-label
              [for]="website"
              [text]="'outlook.abentry.website' | translate"
            ></kendo-label>
            <kendo-textbox
              [maxlength]="256"
              #website
              formControlName="website"
            ></kendo-textbox>
            <maximizer-outlook-form-error
              [errorObject]="form.controls.website.errors"
              [fieldTranslation]="'outlook.abentry.website'"
            ></maximizer-outlook-form-error>
          </kendo-formfield>

          <kendo-formfield class="mt-2">
            <kendo-label [for]="company">
              @if (type() === EntryType.Contact) {
                {{ 'outlook.abentry.company' | translate }}/{{
                  'individual' | translateVertical
                }}
              } @else {
                {{ 'outlook.abentry.company' | translate }}
              }
            </kendo-label>
            <kendo-textbox
              [maxlength]="80"
              #company
              formControlName="company"
              [readonly]="abentry?.type !== EntryType.Individual"
              [ngClass]="
                abentry?.type !== EntryType.Individual ? 'text-neutral-60' : ''
              "
            ></kendo-textbox>
            <maximizer-outlook-form-error
              [errorObject]="form.controls.company.errors"
              [fieldTranslation]="'outlook.abentry.company'"
            ></maximizer-outlook-form-error>
          </kendo-formfield>

          @if (type() === EntryType.Contact) {
            <div class="mt-4">
              {{
                'outlook.abentry.companyAddress'
                  | translate
                    : {
                        label: 'individual' | translateVertical,
                      }
              }}
              <span
                kendoTooltip
                class="fa-icons icon-12 icon-solid icon-circle-question text-neutral-90"
                title="{{
                  'outlook.abentry.companyAddressTooltip' | translate
                }}"
                [tooltipWidth]="250"
                [tooltipTemplate]="tooltip"
                [position]="'bottom'"
                tooltipClass="ml-8"
              ></span>
              <ng-template #tooltip>
                <p class="text-body">
                  {{ 'outlook.abentry.companyAddressTooltip' | translate }}
                </p>
              </ng-template>
            </div>
          }

          <!-- Address Fields -->
          <kendo-formfield class="mt-4">
            <kendo-label
              [for]="address1"
              [text]="'outlook.abentry.address1' | translate"
            ></kendo-label>
            <kendo-textbox
              [maxlength]="80"
              #address1
              formControlName="address1"
            ></kendo-textbox>
            <maximizer-outlook-form-error
              [errorObject]="form.controls.address1.errors"
              [fieldTranslation]="'outlook.abentry.address1'"
            ></maximizer-outlook-form-error>
          </kendo-formfield>

          <kendo-formfield class="mt-2">
            <kendo-label
              [for]="address2"
              [text]="'outlook.abentry.address2' | translate"
            ></kendo-label>
            <kendo-textbox
              [maxlength]="80"
              #address2
              formControlName="address2"
            ></kendo-textbox>
            <maximizer-outlook-form-error
              [errorObject]="form.controls.address2.errors"
              [fieldTranslation]="'outlook.abentry.address2'"
            ></maximizer-outlook-form-error>
          </kendo-formfield>

          <kendo-formfield class="mt-2">
            <kendo-label
              [for]="city"
              [text]="'outlook.abentry.city' | translate"
            ></kendo-label>
            <kendo-textbox
              [maxlength]="80"
              #city
              formControlName="city"
            ></kendo-textbox>
            <maximizer-outlook-form-error
              [errorObject]="form.controls.city.errors"
              [fieldTranslation]="'outlook.abentry.city'"
            ></maximizer-outlook-form-error>
          </kendo-formfield>

          <kendo-formfield class="mt-2">
            <kendo-label
              [for]="province"
              [text]="'outlook.abentry.province' | translate"
            ></kendo-label>
            <kendo-textbox
              [maxlength]="80"
              #province
              formControlName="province"
            ></kendo-textbox>
            <maximizer-outlook-form-error
              [errorObject]="form.controls.province.errors"
              [fieldTranslation]="'outlook.abentry.province'"
            ></maximizer-outlook-form-error>
          </kendo-formfield>

          <kendo-formfield class="mt-2">
            <kendo-label
              [for]="postalCode"
              [text]="'outlook.abentry.postalCode' | translate"
            ></kendo-label>
            <kendo-textbox
              [maxlength]="80"
              #postalCode
              formControlName="postalCode"
            ></kendo-textbox>
            <maximizer-outlook-form-error
              [errorObject]="form.controls.postalCode.errors"
              [fieldTranslation]="'outlook.abentry.postalCode'"
            ></maximizer-outlook-form-error>
          </kendo-formfield>

          <kendo-formfield class="mt-2">
            <kendo-label
              [for]="country"
              [text]="'outlook.abentry.country' | translate"
            ></kendo-label>
            <kendo-dropdownlist
              #country
              [data]="countries"
              formControlName="country"
              [defaultItem]="{
                name:
                  type() === EntryType.Contact
                    ? ''
                    : ('outlook.abentry.country-placeholder' | translate),
                id: '',
              }"
              [virtual]="{ itemHeight: 40 }"
              valueField="id"
              textField="name"
              [valuePrimitive]="true"
            >
            </kendo-dropdownlist>
          </kendo-formfield>

          <!-- Template for emails/phones -->
          <ng-template #templateRef let-data let-i="index" let-prop="prop">
            <div class="mt-2 flex flex-row">
              <kendo-formfield class="min-w-[90px] mr-2">
                <kendo-combobox
                  [data]="prop.includes('email') ? emailOptions : phoneOptions"
                  [formControlName]="prop + 'Description'"
                  (ngModelChange)="
                    onEntryChange($event, prop + 'Description', i)
                  "
                  [allowCustom]="true"
                  [clearButton]="false"
                >
                </kendo-combobox>

                <maximizer-outlook-form-error
                  [type]="prop.includes('email') ? 'email' : 'normal'"
                  [errorObject]="
                    form.group.controls[prop.toString() + 'Description'].errors
                  "
                  [fieldTranslation]="
                    'outlook.abentry.' +
                    (prop.includes('email') ? 'email' : 'phone') +
                    'Description'
                  "
                ></maximizer-outlook-form-error>
              </kendo-formfield>

              <kendo-formfield class="w-full">
                <kendo-textbox
                  [maxlength]="prop.includes('email') ? 256 : 22"
                  [formControlName]="prop"
                  (ngModelChange)="onEntryChange($event, prop, i)"
                  [ngClass]="
                    i === 0 && prop.includes('email') ? 'text-neutral-60' : ''
                  "
                  [readonly]="i === 0 && prop.includes('email')"
                ></kendo-textbox>
                <maximizer-outlook-form-error
                  [type]="prop.includes('email') ? 'email' : 'normal'"
                  [errorObject]="form.group.controls[prop].errors"
                  [fieldTranslation]="
                    'outlook.abentry.' +
                    (prop.includes('email') ? 'email' : 'phone')
                  "
                ></maximizer-outlook-form-error>
              </kendo-formfield>

              @if (i > 0) {
                <button
                  kendoButton
                  themeColor="primary"
                  fillMode="flat"
                  class="ml-1"
                  (click)="onRemoveEntry(i, prop)"
                  iconClass="fa-icons icon-solid icon-12 icon-trash-can"
                ></button>
              }
            </div>

            @if (i >= 0 && i === data.length - 1) {
              <div class="flex justify-end pt-1">
                <button
                  kendoButton
                  themeColor="primary"
                  fillMode="flat"
                  class="text-inline-button"
                  (click)="onAddEntry(prop)"
                  [ngClass]="
                    i + 1 === getFieldLimit(prop) ? 'text-neutral-60' : ''
                  "
                  [disabled]="i + 1 === getFieldLimit(prop)"
                  iconClass="fa-icons icon-solid icon-12 icon-plus"
                >
                  {{
                    'outlook.abentry.add-' +
                      (prop.includes('email') ? 'email' : 'phone') | translate
                  }}
                </button>
              </div>
            }
          </ng-template>
        </form>
      </div>

      <div class="bg-neutral-5 z-40 flex justify-end gap-2 p-2">
        <button
          kendoButton
          id="outlook-abEntry-ui-editAbEntry-cancel"
          class="uppercase"
          themeColor="primary"
          fillMode="flat"
          (click)="cancel()"
          [disabled]="loading"
        >
          {{ 'outlook.buttons.cancel' | translate }}
        </button>
        <button
          kendoButton
          id="outlook-abEntry-ui-editAbEntry-save"
          class="uppercase"
          themeColor="primary"
          [disabled]="!form.valid"
          (click)="save()"
        >
          {{ 'outlook.buttons.save' | translate }}
        </button>
      </div>
    </div>
  }
</div>

<maximizer-outlook-notification
  #notification
  [closable]="true"
  [entryId]="type()"
>
</maximizer-outlook-notification>
